import React, {useState, useEffect} from 'react'
import {Link} from 'gatsby'
import {Menu} from 'semantic-ui-react'
import ShoppingCartIcon from './ShoppingCartIcon'
import Logo from './Logo'
import NavMenu from '../Menu/'
import SearchBar from '../SearchBar'
import UserIcon from './UserIcon'
import * as styles from './styles/header.module.css'


const DesktopMenu = ({
	location,
	location: {pathname},
	token,
	cartCount,
	logout,
	recheckLoggedIn
}) => {
	const [activeItem, setActiveItem] = useState(pathname)

	useEffect(() => {
		setActiveItem(pathname)
	}, [pathname])

	return (
		<Menu size="huge" secondary>
			<Menu.Item
				as={Link}
				to="/"
				header
				className={styles.text}
			>
				<Logo />
				NegosyoNow
			</Menu.Item>
      <Menu.Menu position="right">
				<Menu.Item>
					<SearchBar/>
				</Menu.Item>

				<UserIcon
					token={token}
					activeItem={activeItem}
					logout={logout}
					recheckLoggedIn={recheckLoggedIn}
				/>
				<Menu.Item
					as={Link}
					to="/cart/"
				>
					<ShoppingCartIcon cartCount={cartCount} name="Cart" />
				</Menu.Item>
					<Menu.Item>
						<NavMenu location={pathname}/>
					</Menu.Item>
			</Menu.Menu>
		</Menu>
	)
}

export default DesktopMenu
//active={activeItem === withPrefix('/cart/')}